import Reflux from "reflux";
import { singletonActions } from "logic/singleton";
const AuthzRolesActions = singletonActions(
  "AuthzRoles",
  () => Reflux.createActions({
    load: { asyncResult: true },
    delete: { asyncResult: true },
    addMembers: { asyncResult: true },
    removeMember: { asyncResult: true },
    loadUsersForRole: { asyncResult: true },
    loadRolesForUser: { asyncResult: true },
    loadRolesPaginated: { asyncResult: true }
  })
);
export default AuthzRolesActions;
